import { request } from '@max/meituan-uni-network';
const isWeb = true;
import { reportJSInfo } from '@max/meituan-uni-report';
import { AntiReqTool } from '@nibfe/h5guard-request';
import { ClientType, Platform, Source } from '../type/request';
import { CLIENT_CONTAINER, CLIENT_OS, CLIENT_PLATFORM } from '@lowcode/mcp-protocol/src/base/common';
export const AJAX_ERROR_NAME = '网络错误';
export const API_MAP = {
    PROD: 'https://apihotel.meituan.com',
    TEST: 'http://xuekaiyang-miuwb-sl-api.hotel.test.sankuai.com',
    MOCK: 'https://papi.sankuai.com/api/req/55c7984e-3ce0-443d-8313-23dae5d52a9b'
};
export const API_PATH = {
    CROSS_SUPPLY_DELIVERY: '/landing/page/queryByCapsuleGroupId'
};
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus[RequestStatus["LOADING"] = 1] = "LOADING";
    RequestStatus[RequestStatus["SUCCESS"] = 2] = "SUCCESS";
    RequestStatus[RequestStatus["ERROR"] = 1] = "ERROR";
})(RequestStatus || (RequestStatus = {}));
const getRequestPlatform = (platform) => {
    let result = Platform.MEITUAN;
    if (platform === CLIENT_PLATFORM.DP) {
        result = Platform.DIANPING;
    }
    return result;
};
const getRequestSource = (clientContainer) => {
    let result = Source.MEITUAN_APP;
    switch (clientContainer) {
        case CLIENT_CONTAINER.DIANPING_APP:
        case CLIENT_CONTAINER.DIANPING_WEBVIEW:
            result = Source.DIANPING_APP;
            break;
        case CLIENT_CONTAINER.MEITUAN_WECHAT_MINI_PROGRAM:
            result = Source.WECHAT_MEITUAN_MINIAPP;
            break;
        case CLIENT_CONTAINER.HOTEL_WECHAT_MINI_PROGRAM:
            result = Source.WECHAT_HOTEL_MINIAPP;
            break;
        case CLIENT_CONTAINER.DIANPING_WECHAT_MINI_PROGRAM:
            result = Source.WECHAT_DIANPING_MINIAPP;
            break;
        default:
            break;
    }
    return result;
};
const getRequestClientType = (clientContainer, os) => {
    if ([CLIENT_CONTAINER.MEITUAN_WECHAT_MINI_PROGRAM, CLIENT_CONTAINER.HOTEL_WECHAT_MINI_PROGRAM, CLIENT_CONTAINER.DIANPING_WECHAT_MINI_PROGRAM].indexOf(clientContainer) > -1) {
        return ClientType.WX;
    }
    if (os === CLIENT_OS.ANDROID) {
        return ClientType.ANDROID;
    }
    return ClientType.IPHONE;
};
export const commonParams2RequestParams = (commonParams) => {
    const { userId, token, uuid, platform, appVersion, clientContainer, cityInfo, os, lat = 0, lng = 0 } = commonParams ?? {};
    const result = {
        userId,
        token,
        platform: getRequestPlatform(platform),
        source: getRequestSource(clientContainer),
        uuid,
        clientVersion: appVersion,
        locationCityId: cityInfo?.cityId && Number(cityInfo?.cityId) > 0 ? Number(cityInfo?.cityId) : undefined,
        clientType: getRequestClientType(clientContainer, os),
        position: `${lng},${lat}`
    };
    return result;
};
export const requestDataCenter = (requestConfig) => {
    const { path, method, params } = requestConfig;
    let finalRequestParams = params;
    if (true) {
        try {
            const antiReq = new AntiReqTool({
                autoFillParams: true
            });
            // @ts-ignore
            finalRequestParams = antiReq.addCommonParams(finalRequestParams);
        }
        catch {
            reportJSInfo({
                level: 'info',
                content: '请求加上反爬参数错误',
                secCategory: 'ajaxError'
            }).catch();
        }
    }
    return new Promise((resolve, reject) => {
        request({
            url: `${API_MAP.PROD}${path}`,
            data: {
                ...finalRequestParams
            },
            method,
            header: {
                'content-type': 'application/json'
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'hotel'
            },
            success(res) {
                requestConfig.onNetworkSuccess?.();
                if (res?.data?.status === 0) {
                    requestConfig.onBizSuccess?.();
                    const templateRes = res?.data?.data;
                    resolve(templateRes);
                }
                else {
                    requestConfig.onBizFailed?.();
                    const error = new Error(AJAX_ERROR_NAME);
                    error.name = AJAX_ERROR_NAME;
                    error.message = '请求接口异常-code非0';
                    let tags = {};
                    try {
                        tags = {
                            response: JSON.stringify(res),
                            params: JSON.stringify(finalRequestParams)
                        };
                    }
                    catch (e) { }
                    reportJSInfo({
                        secCategory: 'ajaxError',
                        level: 'info',
                        error,
                        tags
                    }).catch();
                    reject(error);
                }
            },
            fail(error) {
                requestConfig.onNetworkFailed?.();
                if (typeof error === 'object') {
                    error.name = AJAX_ERROR_NAME;
                    error.message = '请求接口异常-网络异常';
                }
                let tags = {};
                try {
                    tags = {
                        errorInfo: JSON.stringify(error),
                        params: JSON.stringify(finalRequestParams)
                    };
                }
                catch (e) { }
                reportJSInfo({
                    secCategory: 'ajaxError',
                    level: 'info',
                    error,
                    tags
                }).catch();
                reject(error);
            }
        });
    });
};
